import * as React from 'react';
import { FolderType, ReportCategory } from 'app/area/case-report/case-listing/types';
import { ReportId } from 'app/area/saved-reports/constants';

export const withSavedDashboard = (WrappedComponent: React.ComponentType) => {

  return (props: any) => {
    return <WrappedComponent {...props} reportCategories={[ReportCategory.DashboardReport]} folderType={FolderType.Dashboard} 
      selectedReport={ReportId.Dashboard}/>;    
  };
};
